<div class="blurred-background"></div>
<div class="layout-box">

  <!-- Header for desktop  -->
  <mat-toolbar color="primary p-0 layout-toolbar">
    <mat-toolbar class=" toolbar-header">
      <app-logo-header></app-logo-header>

      <span class="page-hed-img">
        <a href="https://play.google.com/store/apps/details?id=com.unipanel&pli=1" target="_blank">
          <img src="../../../../../assets/images/playstore.png" alt="android">
        </a>
      </span>
      <span class="page-hed-img">
        <a href="https://apps.apple.com/us/app/opinion-edge/id6446476343" target="_blank">
          <img src="../../../../../assets/images/App-Store.png" class="ios-ico" alt="ios">
        </a>
      </span>

      <span class="example-spacer"></span>

      <div class="user-details" *ngIf="userProfile$ | async as profile">
        <section class="user-profile-ranking">
          <!-- <div class="level-box">

            <span>{{profile?.userProfile?.levelName.replace(' ', '').toLowerCase() | translate}}</span>

            <span class="level-box-icon" [ngbTooltip]="'levelRule3' | translate">
              <svg width="20" height="19" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="uil:info">
                  <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#A6A6A6" />
                  <path id="Vector"
                    d="M12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929C11.1054 10.4804 11 10.7348 11 11V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10ZM12 6C11.7528 6 11.5111 6.07331 11.3055 6.21066C11.1 6.34801 10.9398 6.54324 10.8452 6.77165C10.7505 7.00005 10.7258 7.25139 10.774 7.49386C10.8223 7.73634 10.9413 7.95907 11.1161 8.13388C11.2909 8.3087 11.5137 8.42775 11.7561 8.47598C11.9986 8.52421 12.2499 8.49946 12.4784 8.40485C12.7068 8.31024 12.902 8.15002 13.0393 7.94446C13.1767 7.7389 13.25 7.49723 13.25 7.25C13.25 6.91848 13.1183 6.60054 12.8839 6.36612C12.6495 6.1317 12.3315 6 12 6Z"
                    fill="#A6A6A6" />
                </g>
              </svg>
            </span>
          </div> -->
          <div class="level-box-rank" [matTooltip]="'totalEarnings' | translate">
            <span class="lb-icon-rank">
              <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.91699 3.26561H16.042C16.1953 3.26556 16.3485 3.27529 16.5005 3.29473C16.449 2.93288 16.3247 2.58521 16.1352 2.2727C15.9456 1.96018 15.6947 1.68928 15.3977 1.47634C15.1006 1.2634 14.7635 1.11282 14.4067 1.03369C14.0498 0.954556 13.6807 0.948504 13.3214 1.0159L2.52734 2.85873H2.51504C1.83749 2.9883 1.23497 3.37164 0.830527 3.93047C1.43985 3.49707 2.16925 3.26464 2.91699 3.26561ZM16.042 4.24998H2.91699C2.22103 4.25074 1.55379 4.52755 1.06168 5.01966C0.569558 5.51178 0.292752 6.17902 0.291992 6.87498V14.75C0.292752 15.4459 0.569558 16.1132 1.06168 16.6053C1.55379 17.0974 2.22103 17.3742 2.91699 17.375H16.042C16.738 17.3742 17.4052 17.0974 17.8973 16.6053C18.3894 16.1132 18.6662 15.4459 18.667 14.75V6.87498C18.6662 6.17902 18.3894 5.51178 17.8973 5.01966C17.4052 4.52755 16.738 4.25074 16.042 4.24998ZM14.0938 12.125C13.8342 12.125 13.5804 12.048 13.3646 11.9038C13.1487 11.7596 12.9805 11.5546 12.8812 11.3148C12.7818 11.0749 12.7558 10.811 12.8065 10.5564C12.8571 10.3018 12.9821 10.068 13.1657 9.8844C13.3492 9.70085 13.5831 9.57584 13.8377 9.5252C14.0923 9.47456 14.3562 9.50055 14.596 9.59989C14.8359 9.69923 15.0408 9.86746 15.1851 10.0833C15.3293 10.2991 15.4062 10.5529 15.4062 10.8125C15.4062 11.1606 15.268 11.4944 15.0218 11.7406C14.7757 11.9867 14.4418 12.125 14.0938 12.125Z"
                  fill="#BD1F1F" />
              </svg>

            </span>
            <span class="font-regular fw-bold">{{ profile?.userProfile?.totalAmount | currency:
              profile?.userProfile?.currency:'symbol':'1.2-2' }}</span>
          </div>

          <div class="level-box-rank" [matTooltip]="'currentInfo' | translate">
            <span class="lb-icon-rank">

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.6667 20H9.33333M14.6667 20V12.5329C14.6667 12.3915 14.6105 12.2558 14.5105 12.1558C14.4104 12.0558 14.2748 11.9996 14.1333 11.9996H9.86667C9.72522 11.9996 9.58956 12.0558 9.48954 12.1558C9.38952 12.2558 9.33333 12.3915 9.33333 12.5329V20M14.6667 20H19.4667C19.6081 20 19.7438 19.9438 19.8438 19.8438C19.9438 19.7438 20 19.6081 20 19.4666V17.4221C20 17.2806 19.9438 17.145 19.8438 17.0449C19.7438 16.9449 19.6081 16.8887 19.4667 16.8887H15.2C15.0586 16.8887 14.9229 16.9449 14.8229 17.0449C14.7229 17.145 14.6667 17.2806 14.6667 17.4221V20ZM9.33333 20V15.6442C9.33333 15.5028 9.27714 15.3671 9.17712 15.2671C9.0771 15.167 8.94145 15.1109 8.8 15.1109H4.53333C4.39188 15.1109 4.25623 15.167 4.15621 15.2671C4.05619 15.3671 4 15.5028 4 15.6442V19.4666C4 19.6081 4.05619 19.7438 4.15621 19.8438C4.25623 19.9438 4.39188 20 4.53333 20H9.33333ZM10.9387 5.87747L11.7467 4.16449C11.7685 4.11552 11.804 4.07392 11.849 4.04473C11.8939 4.01554 11.9464 4 12 4C12.0536 4 12.1061 4.01554 12.151 4.04473C12.196 4.07392 12.2315 4.11552 12.2533 4.16449L13.0622 5.87747L14.8684 6.15393C15.1004 6.18949 15.1929 6.48817 15.0249 6.65884L13.7182 7.99225L14.0267 9.87502C14.0658 10.1168 13.824 10.3017 13.616 10.187L12 9.2981L10.384 10.187C10.1769 10.3008 9.93422 10.1168 9.97333 9.87502L10.2818 7.99225L8.97511 6.65884C8.80622 6.48817 8.89956 6.18949 9.13067 6.15393L10.9387 5.87747Z"
                  stroke="#BD1F1F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span>{{profile?.userProfile?.currentRank || 0}}</span>
          </div>
        </section>

        <section class="btn-group action-header-btn">
          <!-- <button matTooltip="Inbox" class="chat-mat-icon" mat-icon-button type="button" matSuffix
            [matMenuTriggerFor]="menuForInbox" #menuTrigger class="custom-menu-panel">
            <span> <mat-icon>mark_email_unread</mat-icon></span>
          </button> -->
          <button [matBadgeHidden]="notificationCount === 0" [matBadge]="notificationCount"
            [matTooltip]="'notification' | translate" class="chat-mat-icon" mat-icon-button type="button" matSuffix
            [matMenuTriggerFor]="menuForNotification" #menuTrigger="matMenuTrigger" class="custom-menu-panel">
            <span> <mat-icon>notifications_active</mat-icon></span>
          </button>
          <!-- 
          <mat-menu #menuForInbox="matMenu">
            <section class="d-flex justify-content-between align-item-center p-3">
              <div class="menu-heading">Inbox</div>
              <div class="d-flex align-item-center gap-2">
                <a class="common-link" routerLink="/inbox">Show all mails</a>
                <mat-icon class="cursor-pointer">close</mat-icon>
              </div>
            </section>
            <mat-divider></mat-divider>
            <mat-list role="list">
              <mat-list-item role="listitem" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>Event Title</small>
                  <small>3d ago</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>Hi Anastassia!</h6>
                  <p class="addtext-ellipsis">Lorem ipsum dolor Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit perspiciatis exercitationem id impedit assumenda voluptas voluptatum consequatur? Minima cum laborum, iure corporis doloremque facere error ut sint iste necessitatibus quidem et molestiae nobis in id amet explicabo aut at ab labore placeat porro blanditiis quaerat earum. Repudiandae tempore nostrum dolorem! sit amet, consectetur adipis</p>
                </div>
              </mat-list-item>
              <mat-list-item role="listitem" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>Event Title</small>
                  <small>3d ago</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>Hi Anastassia!</h6>
                  <p class="addtext-ellipsis">Lorem ipsum dolor Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit perspiciatis exercitationem id impedit assumenda voluptas voluptatum consequatur? Minima cum laborum, iure corporis doloremque facere error ut sint iste necessitatibus quidem et molestiae nobis in id amet explicabo aut at ab labore placeat porro blanditiis quaerat earum. Repudiandae tempore nostrum dolorem! sit amet, consectetur adipis</p>
                </div>
              </mat-list-item>
              <mat-list-item role="listitem" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>Event Title</small>
                  <small>3d ago</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>Hi Anastassia!</h6>
                  <p class="addtext-ellipsis">Lorem ipsum dolor Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit perspiciatis exercitationem id impedit assumenda voluptas voluptatum consequatur? Minima cum laborum, iure corporis doloremque facere error ut sint iste necessitatibus quidem et molestiae nobis in id amet explicabo aut at ab labore placeat porro blanditiis quaerat earum. Repudiandae tempore nostrum dolorem! sit amet, consectetur adipis</p>
                </div>
              </mat-list-item>
              <mat-list-item role="listitem" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>Event Title</small>
                  <small>3d ago</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>Hi Anastassia!</h6>
                  <p class="addtext-ellipsis">Lorem ipsum dolor Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit perspiciatis exercitationem id impedit assumenda voluptas voluptatum consequatur? Minima cum laborum, iure corporis doloremque facere error ut sint iste necessitatibus quidem et molestiae nobis in id amet explicabo aut at ab labore placeat porro blanditiis quaerat earum. Repudiandae tempore nostrum dolorem! sit amet, consectetur adipis</p>
                </div>
              </mat-list-item>
              <mat-list-item role="listitem" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>Event Title</small>
                  <small>3d ago</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>Hi Anastassia!</h6>
                  <p class="addtext-ellipsis">Lorem ipsum dolor Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit perspiciatis exercitationem id impedit assumenda voluptas voluptatum consequatur? Minima cum laborum, iure corporis doloremque facere error ut sint iste necessitatibus quidem et molestiae nobis in id amet explicabo aut at ab labore placeat porro blanditiis quaerat earum. Repudiandae tempore nostrum dolorem! sit amet, consectetur adipis</p>
                </div>
              </mat-list-item>

            </mat-list>
          </mat-menu> -->

          <mat-menu [hasBackdrop]="true" #menuForNotification="matMenu">

            <div (click)="$event.stopPropagation()">
              <section class="d-flex justify-content-between align-item-center p-3">
                <div class="menu-heading">{{'notifications' | translate}}</div>
                <div class="d-flex align-item-center gap-2 lay-icon-group">
                  @if (notifications.length !== 0) {
                  <mat-icon class="cursor-pointer" (click)="readAll()"
                    [ngbTooltip]="'ReadNotification' | translate">mark_email_read</mat-icon>
                  <mat-icon class="cursor-pointer" (click)="deleteAll()"
                    [ngbTooltip]="'clearAll' | translate">delete</mat-icon>
                  }
                  @if (notifications.length === 0) {
                    <mat-icon class="cursor-pointer" (click)="closeMenu()">cancel</mat-icon>
                  }
                </div>
              </section>
              <mat-divider></mat-divider>
              @for (item of notifications; track $index) {
              <mat-list-item (click)="$event.stopPropagation()" role="listitem"
                [ngClass]="{'menu-data-active': !item?.isRead && notificationCount != 0}" class="menu-data">
                <div class="menu-list-hed  flex-between">
                  <small>{{item?.notificationType}}</small>
                  <small>{{item?.createdAt | membershipDate}}</small>
                </div>
                <div class="menu-list-content flex-gap">
                  <h6>{{'hi' | translate}} {{profile?.userProfile?.firstName}}!</h6>
                  <p class="text-wrap">{{item?.notification}}</p>
                </div>
              </mat-list-item>
              }

              @if (notifications.length === 0) {
              <h5 class="text-center">{{'notificationNotFound' | translate}}</h5>
              }

            </div>

          </mat-menu>

        </section>

        <section class="level-box-email">
          <div class="user-name">
            <span class="user-img">
              <img loading="lazy" [src]="profileImage || 'https://panel-api.opinion-edge.com/uploads/unimrktdp.webp'"
                alt="profile">
            </span>
            <span class="user-name-hed">
              <h5>{{ profile?.userProfile?.email }}</h5>
            </span>

          </div>
        </section>

        <section class="log-out" [matTooltip]="'signOut' | translate">
          <div class="hed-theame" (click)="onLogout()">
            <mat-icon>power_settings_new</mat-icon>
          </div>
        </section>
      </div>

    </mat-toolbar>
  </mat-toolbar>

  <!-- Sidenav Container -->
  <mat-sidenav-container class="sidenav-container">
    <!-- Sidenav for mobile -->
    <mat-sidenav mode="side" class="sidenav" disableClose fixedInViewport [opened]="!isMobile"
      [class.collapsed]="isCollapsed">
      <app-side-nav (isCollapsed)="onCollapsed($event)"></app-side-nav>

      <!-- Fixed Footer Menu (Help & Security) -->
      <!-- <div class="fixed-footer" [class.collapsed]="isCollapsed">

        <a [routerLinkActive]="['activeButtum']" class="menu-item-link" [matTooltip]="'privacyPolicy' | translate" routerLink="/userPrivacy" matTooltipClass="custom-tooltip"
          matTooltipPosition="right">
          <mat-icon>security</mat-icon>
           <span class="fs-7 nav-text">{{'privacyPolicy' | translate}}</span>
        </a>
        <a [routerLinkActive]="['activeButtum']" class="menu-item-link" [matTooltip]="'FAQues' | translate" routerLink="/userFaqs"
          matTooltipClass="custom-tooltip" matTooltipPosition="right">
          <mat-icon>help</mat-icon>
           <span class="fs-7 nav-text">{{'faqs' | translate}}</span>
        </a>
      </div> -->
    </mat-sidenav>

    <!-- Sidenav content -->
    <mat-sidenav-content class="sidenav-content" [class.expanded]="isCollapsed" [ngClass]="{'ml-collapsed': isMobile}">
      <!-- Toolbar for mobile -->
      <!-- Button to open the bottom sheet on mobile -->
      <div class="bottom-navigation mb-2">
        <button mat-icon-button data-bs-toggle="offcanvas" data-bs-target="#openSidenavBox" (click)="toggleSideNav()"
          aria-controls="offcanvasWithBothOptions">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="page-hed">{{activeItem?.text | translate}}</span>
      </div>
      <mat-divider class="lay-divider"></mat-divider>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <div class="offcanvas offcanvas-start" data-bs-scroll="true" tabindex="-1" id="openSidenavBox"
    aria-labelledby="openSidenavBoxLabel">
    <div class="offcanvas-header">
      <app-logo-header></app-logo-header>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <app-side-nav data-bs-dismiss="offcanvas" aria-label="Close"></app-side-nav>
    </div>
  </div>
<div class="footer-festival-overlay" #festivalOverlay [class.is-hovered]="isHovered"></div>
</div>